import { render, staticRenderFns } from "./ElementsFooterInvestment.vue?vue&type=template&id=6913ede5&scoped=true"
import script from "./ElementsFooterInvestment.vue?vue&type=script&lang=ts"
export * from "./ElementsFooterInvestment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6913ede5",
  null
  
)

export default component.exports